"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PureFormProvider = void 0;
/* eslint-disable react/require-default-props */
const react_1 = __importStar(require("react"));
const query_string_1 = __importDefault(require("query-string"));
const isFunction_1 = require("../../utils/isFunction");
const validation_1 = require("../../shared/validation");
const usePushQueryValue_1 = require("../../hooks/usePushQueryValue");
const useCookies_1 = __importDefault(require("../../hooks/useCookies"));
const FormContext_1 = __importDefault(require("../../context/FormContext"));
const utils_1 = require("./utils");
var ReducerActionType;
(function (ReducerActionType) {
    ReducerActionType["SetValue"] = "set-value";
    ReducerActionType["SetValues"] = "set-values";
    ReducerActionType["Reset"] = "reset";
    ReducerActionType["SetTouched"] = "set-touched";
    ReducerActionType["SetErrors"] = "set-errors";
    ReducerActionType["CommitValue"] = "commit-value";
    ReducerActionType["CommitValues"] = "commit-values";
})(ReducerActionType || (ReducerActionType = {}));
const mergePersistedValues = (obj1, obj2) => {
    return [...Object.keys(obj1), ...Object.keys(obj2)].reduce((acc, key) => {
        const value1 = obj1[key];
        const value2 = obj2[key];
        acc[key] =
            value2 !== '' && value2 !== null && value2 !== undefined ? value2 : value1;
        return acc;
    }, {});
};
const getPersistedValues = ({ formName, initialValues, persistFieldsOptions, fieldsOptions, cookies, }) => {
    const { getQueryValue, type } = persistFieldsOptions;
    switch (type) {
        case 'cookies':
            return (0, utils_1.getPersistedCookiesFormFields)(formName, cookies, initialValues);
        case 'query': {
            const { query } = persistFieldsOptions;
            return (0, utils_1.getPersistedQueryFormFields)({
                initialValues,
                query,
                fieldsOptions,
                getQueryValue,
            });
        }
        case 'query-and-cookies': {
            const { query } = persistFieldsOptions;
            return mergePersistedValues((0, utils_1.getPersistedCookiesFormFields)(formName, cookies, initialValues), (0, utils_1.getPersistedQueryFormFields)({
                initialValues,
                query,
                fieldsOptions,
                getQueryValue,
            }));
        }
        default:
            return initialValues;
    }
};
const persistFields = (() => {
    const fieldTimeoutFunctions = {};
    return ({ currentValues, debouncePersisting, fieldName, fieldsOptions, formName, initialValues, type, updatedValues, errors, fieldsToReset = [], }) => {
        var _a;
        if (fieldName && fieldTimeoutFunctions[fieldName]) {
            window.clearTimeout(fieldTimeoutFunctions[fieldName]);
        }
        const fieldsToResetMap = (_a = fieldsToReset.reduce((acc, curr) => ((acc[curr] = true), acc), {})) !== null && _a !== void 0 ? _a : {};
        const functionToExecute = () => {
            if (fieldName) {
                fieldTimeoutFunctions[fieldName] = undefined;
            }
            const getValuesToPersist = (acc, [currFieldName, currValue]) => {
                const initialValue = initialValues[currFieldName];
                // Do not persist if value is empty, when we reset or if field value is initial
                if (currValue === '' ||
                    fieldsToResetMap[currFieldName] ||
                    (0, utils_1.isFormValueInitial)(currValue, initialValue)) {
                    acc[currFieldName] = undefined;
                    return acc;
                }
                const currFieldErrors = errors[currFieldName];
                if (currFieldErrors && currFieldErrors.length) {
                    return acc;
                }
                acc[currFieldName] = currValue;
                return acc;
            };
            const currentValuesToPersist = Object.entries(currentValues).reduce(getValuesToPersist, {});
            const updatedValuesToPersist = Object.entries(updatedValues).reduce(getValuesToPersist, {});
            if (!Object.keys(updatedValuesToPersist).length) {
                return;
            }
            const valuesToPersist = Object.assign(Object.assign({}, currentValuesToPersist), updatedValuesToPersist);
            if (type === 'query' || type === 'query-and-cookies') {
                // setTimeout is needed, as otherwise there is delay of updating the input value
                window.setTimeout(() => {
                    (0, usePushQueryValue_1.pushQueryValues)(valuesToPersist);
                }, 10);
            }
            if (type === 'cookies') {
                window.setTimeout(() => {
                    (0, utils_1.persistFormFields)(formName, valuesToPersist);
                }, 11);
            }
            if (type === 'query-and-cookies') {
                window.setTimeout(() => {
                    const trimmedValuesToPersist = Object.entries(valuesToPersist).reduce((acc, [currFieldName, currValue]) => {
                        const { isRequired, isPersisted } = fieldsOptions[currFieldName] || {};
                        if (!isRequired && !isPersisted) {
                            return acc;
                        }
                        acc[currFieldName] = currValue;
                        return acc;
                    }, {});
                    (0, utils_1.persistFormFields)(formName, trimmedValuesToPersist);
                }, 11);
            }
        };
        if (!debouncePersisting) {
            functionToExecute();
            return;
        }
        if (fieldName) {
            fieldTimeoutFunctions[fieldName] = window.setTimeout(functionToExecute, 500);
        }
    };
})();
const getUpdatedValues = ({ initialValues, name, resetFieldsOnChange, value, }) => [...resetFieldsOnChange, name].reduce((acc, currName) => {
    const isFieldToReset = currName !== name;
    acc[currName] = isFieldToReset ? initialValues[currName] : value;
    return acc;
}, {});
const validateForm = ({ fieldsOptions, values, }) => Object.entries(values).reduce((acc, [name, value]) => {
    const { validationRules, isRequired, isRequiredMessage } = (fieldsOptions &&
        fieldsOptions[name]) || {
        isRequired: undefined,
        isRequiredMessage: undefined,
        validationRules: undefined,
        resetFieldsOnChange: [],
    };
    const fieldErrors = (0, validation_1.validate)(value, isRequired, validationRules, isRequiredMessage);
    if (fieldErrors.length) {
        acc[name] = fieldErrors;
    }
    return acc;
}, {});
const reducer = (state, action) => {
    var _a, _b;
    let updatedState;
    const { actionType } = action;
    switch (actionType) {
        case ReducerActionType.SetValue: {
            const { initialValues, fieldName, fieldsOptions, value } = action;
            const { resetFieldsOnChange = [] } = (_a = fieldsOptions === null || fieldsOptions === void 0 ? void 0 : fieldsOptions[fieldName]) !== null && _a !== void 0 ? _a : {};
            const values = getUpdatedValues({
                initialValues,
                name: fieldName,
                resetFieldsOnChange,
                value,
            });
            updatedState = Object.assign(Object.assign({}, state), { values: Object.assign(Object.assign({}, state.values), values) });
            break;
        }
        case ReducerActionType.CommitValue: {
            const { initialValues, fieldName, shouldReset, formName, persistType, fieldsOptions = {}, value, } = action;
            const { isRequired, isRequiredMessage, validationRules, resetFieldsOnChange = [], debouncePersisting, } = (_b = fieldsOptions === null || fieldsOptions === void 0 ? void 0 : fieldsOptions[fieldName]) !== null && _b !== void 0 ? _b : {};
            const fieldErrors = shouldReset
                ? []
                : (0, utils_1.validateValue)({
                    isRequired,
                    isRequiredMessage,
                    value,
                    validationRules,
                });
            const errors = Object.assign(Object.assign({}, state.errors), { [fieldName]: fieldErrors });
            const values = getUpdatedValues({
                initialValues,
                name: fieldName,
                resetFieldsOnChange,
                value,
            });
            updatedState = Object.assign(Object.assign({}, state), { values: Object.assign(Object.assign({}, state.values), values), committedValues: Object.assign(Object.assign({}, state.committedValues), values), errors });
            persistFields({
                updatedValues: values,
                type: persistType,
                formName,
                fieldName,
                debouncePersisting: !!debouncePersisting && !shouldReset,
                initialValues,
                errors,
                currentValues: state.values,
                fieldsOptions,
                fieldsToReset: resetFieldsOnChange,
            });
            break;
        }
        case ReducerActionType.CommitValues: {
            const { initialValues, fields, formName, persistType, fieldsOptions = {}, debouncePersisting, } = action;
            const updatedErrors = fields.reduce((acc, { name, value }) => {
                var _a;
                const { isRequired, isRequiredMessage, validationRules } = (_a = fieldsOptions === null || fieldsOptions === void 0 ? void 0 : fieldsOptions[name]) !== null && _a !== void 0 ? _a : {};
                acc[name] = (0, utils_1.validateValue)({
                    isRequired,
                    isRequiredMessage,
                    value,
                    validationRules,
                });
                return acc;
            }, {});
            const errors = Object.assign(Object.assign({}, state.errors), updatedErrors);
            const updatedValues = fields.reduce((acc, { name, value }) => {
                var _a;
                const { resetFieldsOnChange = [] } = (_a = fieldsOptions === null || fieldsOptions === void 0 ? void 0 : fieldsOptions[name]) !== null && _a !== void 0 ? _a : {};
                const values = getUpdatedValues({
                    initialValues,
                    name,
                    resetFieldsOnChange,
                    value,
                });
                return Object.assign(acc, values);
            }, {});
            updatedState = Object.assign(Object.assign({}, state), { values: Object.assign(Object.assign({}, state.values), updatedValues), committedValues: Object.assign(Object.assign({}, state.committedValues), updatedValues), errors });
            persistFields({
                updatedValues,
                type: persistType,
                formName,
                initialValues,
                errors,
                currentValues: state.values,
                fieldsOptions,
                debouncePersisting,
            });
            break;
        }
        case ReducerActionType.SetTouched: {
            const { touched } = action;
            updatedState = Object.assign(Object.assign({}, state), { touched: Object.assign(Object.assign({}, state.touched), touched) });
            break;
        }
        case ReducerActionType.SetErrors: {
            const { errors } = action;
            const allErrors = Object.assign(Object.assign({}, state.errors), errors);
            const newlyTouched = Object.fromEntries(Object.entries(allErrors).map(([key]) => [key, true]));
            updatedState = Object.assign(Object.assign({}, state), { errors: allErrors, touched: Object.assign(Object.assign({}, state.touched), newlyTouched) });
            break;
        }
        case ReducerActionType.Reset: {
            const { values, committedValues } = action;
            updatedState = {
                values: values,
                committedValues: committedValues,
                errors: {},
                touched: {},
            };
            break;
        }
        default:
            throw new Error('Invalid form action');
    }
    return updatedState;
};
function FormProvider({ children, fieldsOptions, initialValues, name: formName, onSubmit, persistFieldsOptions = {}, }) {
    const cookies = (0, useCookies_1.default)();
    const { type: persistType } = persistFieldsOptions;
    const persistedValues = (0, react_1.useMemo)(() => {
        var _a;
        return persistType
            ? (_a = getPersistedValues({
                formName,
                persistFieldsOptions,
                initialValues,
                fieldsOptions,
                cookies,
            })) !== null && _a !== void 0 ? _a : {}
            : {};
    }, [formName, persistFieldsOptions, initialValues, fieldsOptions, cookies, persistType]);
    const initialStateStorageValues = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, initialValues), persistedValues)), [
        initialValues,
        persistedValues,
    ]);
    const [{ values, committedValues, errors, touched }, dispatch] = (0, react_1.useReducer)(reducer, {
        values: initialStateStorageValues,
        committedValues: initialStateStorageValues,
        errors: {},
        touched: {},
    });
    (0, react_1.useEffect)(() => {
        const popstateHandler = (params) => {
            const { state: { as: asUrl }, } = params;
            const { query: popStateQuery } = query_string_1.default.parseUrl(asUrl);
            const navigationValues = Object.assign(Object.assign({}, initialValues), getPersistedValues({
                formName,
                persistFieldsOptions: Object.assign(Object.assign({}, persistFieldsOptions), { type: 'query', query: popStateQuery }),
                initialValues,
                fieldsOptions,
                cookies,
            }));
            dispatch({
                actionType: ReducerActionType.Reset,
                committedValues: navigationValues,
                values: navigationValues,
                errors: {},
                touched: {},
            });
        };
        window.addEventListener('popstate', popstateHandler);
        return () => {
            window.removeEventListener('popstate', popstateHandler);
        };
    }, []);
    const dirty = (0, react_1.useMemo)(() => Object.fromEntries(Object.entries(committedValues).map(([key, value]) => [
        key,
        !(0, utils_1.isFormValueInitial)(value, initialValues[key]),
    ])), [committedValues, initialValues]);
    const isValid = (0, react_1.useMemo)(() => !Object.values(errors).some((validationErrors) => {
        return validationErrors && validationErrors.length;
    }), [errors]);
    const handleSubmit = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        if (!isValid) {
            return;
        }
        const errorsOnSubmit = validateForm({ values, fieldsOptions });
        if (Object.keys(errorsOnSubmit).length) {
            dispatch({ errors: errorsOnSubmit, actionType: ReducerActionType.SetErrors });
            return;
        }
        const allTouched = Object.fromEntries(Object.entries(values).map(([key]) => [key, true]));
        dispatch({ touched: allTouched, actionType: ReducerActionType.SetTouched });
        onSubmit(values);
    }, [onSubmit, isValid, values, fieldsOptions]);
    const handleSetValue = (0, react_1.useCallback)((name, value) => {
        var _a;
        const { disableAutoCommit } = (_a = fieldsOptions === null || fieldsOptions === void 0 ? void 0 : fieldsOptions[name]) !== null && _a !== void 0 ? _a : {};
        dispatch({
            fieldName: name,
            value,
            fieldsOptions,
            initialValues,
            actionType: disableAutoCommit ? ReducerActionType.SetValue : ReducerActionType.CommitValue,
            formName,
            persistType,
        });
    }, [fieldsOptions, initialValues, formName, persistType]);
    const handleSetValues = (0, react_1.useCallback)((fields, debouncePersisting = false) => {
        dispatch({
            fields,
            fieldsOptions,
            initialValues,
            actionType: ReducerActionType.CommitValues,
            formName,
            persistType,
            debouncePersisting,
        });
    }, [fieldsOptions, initialValues, formName, persistType]);
    const handleResetValue = (0, react_1.useCallback)((name) => {
        dispatch({
            fieldName: name,
            value: initialValues[name],
            fieldsOptions,
            initialValues,
            actionType: ReducerActionType.CommitValue,
            shouldReset: true,
            formName,
            persistType,
        });
    }, [fieldsOptions, formName, initialValues, persistType]);
    const handleSetTouched = (0, react_1.useCallback)((name) => {
        dispatch({
            actionType: ReducerActionType.SetTouched,
            touched: { [name]: true },
        });
    }, []);
    const handleReset = (0, react_1.useCallback)(() => {
        const valuesToKeep = Object.fromEntries(Object.entries(values).filter(([key]) => { var _a; return (_a = fieldsOptions === null || fieldsOptions === void 0 ? void 0 : fieldsOptions[key]) === null || _a === void 0 ? void 0 : _a.ignoreReset; }));
        const valuesToReset = Object.assign(Object.assign({}, initialValues), valuesToKeep);
        dispatch({
            actionType: ReducerActionType.Reset,
            committedValues: initialValues,
            errors: {},
            touched: {},
            values: valuesToReset,
        });
        if (persistType) {
            persistFields({
                type: persistType,
                currentValues: initialValues,
                updatedValues: valuesToReset,
                errors: {},
                formName,
                debouncePersisting: false,
                initialValues,
                fieldsOptions: fieldsOptions !== null && fieldsOptions !== void 0 ? fieldsOptions : {},
            });
        }
    }, [initialValues, formName, persistType, fieldsOptions]);
    const handleCommitValue = (0, react_1.useCallback)((name, value) => {
        dispatch({
            fieldName: name,
            value,
            fieldsOptions,
            initialValues,
            actionType: ReducerActionType.CommitValue,
            formName,
            persistType,
        });
    }, [fieldsOptions, initialValues, formName, persistType]);
    const context = (0, react_1.useMemo)(() => ({
        commitValue: handleCommitValue,
        dirty,
        errors,
        onReset: handleReset,
        onSubmit: handleSubmit,
        resetValue: handleResetValue,
        setValue: handleSetValue,
        setValues: handleSetValues,
        touchField: handleSetTouched,
        touched,
    }), [
        dirty,
        errors,
        handleCommitValue,
        handleReset,
        handleResetValue,
        handleSetTouched,
        handleSetValue,
        handleSetValues,
        handleSubmit,
        touched,
    ]);
    const childrenProps = (0, react_1.useMemo)(() => ({
        committedValues,
        dirty,
        errors,
        fieldsOptions,
        handleReset,
        handleResetValue,
        initialValues,
        isValid,
        setValues: handleSetValues,
        touched,
        values,
    }), [
        committedValues,
        dirty,
        errors,
        fieldsOptions,
        handleReset,
        handleResetValue,
        initialValues,
        isValid,
        touched,
        values,
        handleSetValues,
    ]);
    return (react_1.default.createElement(FormContext_1.default.Provider, { value: context }, (0, isFunction_1.isFunction)(children) ? children(childrenProps) : children));
}
exports.PureFormProvider = FormProvider;
exports.default = (0, react_1.memo)(FormProvider);
//# sourceMappingURL=FormProvider.js.map